import UploadContainer from './UploadContainer'
import Upload from './Upload'
export { Upload }
export { UploadContainer }
export default UploadContainer



// WEBPACK FOOTER //
// ./src/components/Upload/index.js